import React from 'react';
import { List, Loader, Header, Icon } from 'semantic-ui-react';
import ConversationPreview from './ConversationPreview';
import './ConversationList.css';

const ConversationList = ({
  conversations = [],
  onConversationSelect,
  selectedConversationId = null,
  loading = false
}) => {
  if (loading) {
    return (
      <div className="conversation-list-loading">
        <Loader active inline="centered" />
        <p>Loading conversations...</p>
      </div>
    );
  }

  if (conversations.length === 0) {
    return (
      <div className="conversation-list-empty">
        <Icon name="comments outline" size="large" />
        <Header as="h4">No conversations yet</Header>
        <p>Start a conversation by inquiring about an opportunity or contacting a voice actor.</p>
      </div>
    );
  }

  return (
    <div className="conversation-list-container">
      <div className="conversation-list-header">
        <Header as="h4">
          <Icon name="comments" />
          Conversations ({conversations.length})
        </Header>
      </div>

      <List className="conversation-list" divided relaxed>
        {conversations.map((conversation) => (
          <ConversationPreview
            key={conversation.conversationId}
            conversation={conversation}
            isSelected={conversation.conversationId === selectedConversationId}
            onClick={(threadId) => onConversationSelect(conversation, threadId)}
          />
        ))}
      </List>
    </div>
  );
};

export default ConversationList;
